import {strings} from '@app/common/strings';
import {
  getFlatRows,
  updatedDailyData,
  updatedMiscData,
} from '@app/screens/module-specific-utilities/components/approve-expenses/utils';
import {createAction, createSlice} from '@reduxjs/toolkit';
import { set } from 'lodash';

export const aiSummaryExpenseInitialState = {
  hqDropDownForAISummaryExpense: [],
  categoryDropDownForAISummaryExpense: [],
  aiSummarySummaryData: {},
  aiSummaryCategoriesData: [],
  aiSummaryExpenseData: [],
  aiSummaryExpenseCompleteData: [],
  aiSummaryPaginationData:{},
  showLoader: false,
};


export const fetchHqForAISummaryExpenseCreator = createAction<any>(
  'APPROVE_EXPENSE_HANDLER/HQ_DROPDOWN',
);

export const fetchHqForAISummaryExpenseCreatorTypeName =
  fetchHqForAISummaryExpenseCreator({}).type;

export const fetchAISummaryExpenseCreator = createAction<any>(
  'APPROVE_EXPENSE_HANDLER/AISUMMARY_EXPENSE',
);

export const fetchAISummaryExpenseCreatorTypeName =
  fetchAISummaryExpenseCreator({}).type;

export const fetchCategoryForAISummaryExpenseCreator = createAction<any>(
  'APPROVE_EXPENSE_HANDLER/CATEGORY_DROPDOWN',
);

export const fetchCategoryForAISummaryExpenseCreatorTypeName =
  fetchCategoryForAISummaryExpenseCreator({}).type;


const aiSummaryExpenseStateHandler = createSlice({
  name: 'AI_SUMMARY_EXPENSE_HANDLER',
  initialState: aiSummaryExpenseInitialState,
  reducers: {
      setHQAISummaryExpenseData: (prevState, {payload}) => ({
      ...prevState,
      hqDropDownForAISummaryExpense: payload,
    }),
    setCategoryAISummaryExpenseData: (prevState, {payload}) => ({
      ...prevState,
      categoryDropDownForAISummaryExpense: payload,
    }),
    setAISummaryExpenseData: (prevState, {payload}) => ({
      ...prevState,
      aiSummarySummaryData: payload?.summary || {},
      aiSummaryCategoriesData: payload?.categories || [],
      aiSummaryExpenseCompleteData: payload?.categories || [],
      aiSummaryExpenseData: payload?.categories || [],
      aiSummaryPaginationData: payload?.pagination || {},
    }),

      setAISummaryExpenseCompleteData: (prevState, {payload}) => ({
      ...prevState,
      aiSummarySummaryData: {},
      aiSummaryCategoriesData: [],
      aiSummaryExpenseData: [],
      aiSummaryExpenseCompleteData: [],
      aiSummaryPaginationData: {},
    }),

    setShowLoader: (prevState, {payload}) => ({
      ...prevState,
      showLoader: payload,
    }),
  },
});

export const aiSummaryExpenseStateActions = aiSummaryExpenseStateHandler.actions;
export const aiSummaryExpenseReducer = aiSummaryExpenseStateHandler.reducer;
